import React, { useState, useRef, useEffect } from "react";
import {
  Paper,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Backdrop } from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
import Card from "../../../../StyledComponents/Card/Card";
import CardHeader from "../../../../StyledComponents/Card/CardHeader";
import CardText from "../../../../StyledComponents/Card/CardText";
import CardBody from "../../../../StyledComponents/Card/CardBody";
import { useMediaQuery } from "@mui/material";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AddIcon from "@mui/icons-material/Add";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";

import CustomSnackbar from "../../../../CustomSnackbar";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import { HelpOutline } from "@material-ui/icons";
import { getRefrenceDataList } from "../adminaction";
import { ArrowBack, Delete, Error } from "@mui/icons-material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import SG_PM_TT_PTModel from "./SG_PM_TT_PTModel";
import { dashboardStyle } from "../../Components/InvoiceDetails/style";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const useStyles = makeStyles(dashboardStyle);

const SG_PM_TT_PTSetting = ({ refKey, invoiceLoader, setInvoiceLoader }) => {
  const matches = useMediaQuery("(max-width:700px)");

  const [getdata, setGetData] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [togglebutton, settogglebutton] = useState("");
  const [deleteId, setDeleteID] = useState(false);
  const [searchApi, setSearchAPi] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [Loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [getdataFromID, setGetDataFromID] = useState("");




  const classes = useStyles();

  const handleSearchInput = (e) => {
    const inputValue = e.target.value;
    if (inputValue=== "") {
      setGetData(searchApi);
    } else {
      const fiterData = searchApi.filter(
        (data) =>
          data.referenceCode
            .toLowerCase()
            .includes(inputValue.toLowerCase()) ||
          data.referenceText.toLowerCase().includes(inputValue.toLowerCase())
      );
      if (fiterData.length > 0) {
        setGetData(fiterData);
      } else {
        let msg = "No Records Found";
        setGetData([{ message: msg }]);
      }
    }
  };

  useEffect(() => {
    getRefrenceDataList(
      refKey,
      setGetData,
      setSearchAPi,
      setInvoiceLoader,
      () => { },
      () => { },
      () => { },
      () => { }
    );
    // 
  }, []);

  return (
    <>
      <div>
        {/* <Box display="flex" justifyContent={"end"} style={{marginTopL:"10px"}}>
    <Button
      variant="contained"
      size={"small"}
      color="secondary"
    
      onClick={()=>{
        setOpenModel(true)
        setDeleteID("")
        settogglebutton("");

      }}
    >
      Add New Item
    </Button>
  </Box> */}
        <Card style={{ marginTop: "24px" }}>
          <CardBody>
            {/* <AddIcon /> */}
            <Grid container spacing={2} pb={2}>
              <Grid item xs={6} sm={6} md={4} lg={4} mt={-2} >
                <TextField
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    }
                  }}
                  fullWidth
                  id="outlined-basic"
                  placeholder="Search here...."
                  variant="outlined"
                  type="search"
                  value={searchInput}
                  onChange={(e) => {
                    handleSearchInput(e);
                    setSearchInput(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={8} lg={8} mt={-2}  >
                <Box
                  display="flex"
                  justifyContent={"end"}
                  style={{ marginTopL: "10px" }}
                >
                  <Button
                    variant="contained"
                    size={"small"}
                    color="secondary"
                    sx={{
                      color: "#fff",
                      fontSize: matches ? "10px" : "15px",
                      height: 30,
                      width: matches ? "117px" : "151px",
                    }}
                    onClick={() => {
                      setOpenModel(true)
                      setDeleteID("")
                      settogglebutton("");

                    }}
                  >
                    {/* <AddIcon /> */}
                    Add New Item
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <TableContainer
              className="scrollable"
              sx={{
                height: 290,
              }}
            >
              <Table
                className={classes.table}
                aria-label="a dense table"
                // padding="normal"
                size="small"
                sx={{
                  height: "max-content",
                }}
              >
                <TableHead
                  style={{
                    position: "sticky",
                    top: "0px",
                  }}
                >
                  <TableRow sx={{ backgroundColor: "#A5ACB0" }}>
                    <TableCell
                      sx={{ fontWeight: "bold", color: "#fff", width: "20%" }}
                    >
                      SR#
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", color: "#fff", width: "24%" }}
                    >
                      Code
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", color: "#fff", width: "20%" }}
                    >
                      Description
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                      Enable
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ fontWeight: "bold", color: "#fff" }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getdata.map((item, index) => {
                    return (
                      <>
                        {item.message ? (
                          <>
                            <TableRow
                            // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            >
                              <TableCell
                                colSpan={5}
                                align="center"
                                style={{
                                  border: "none",
                                  textAlign: "center",
                                  padding: "20px",
                                }}
                              >
                                <Typography>
                                  <EmptyData />
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </>
                        ) : (
                          <TableRow key={index}>
                            <TableCell align="left" scope="row">
                              {index + 1}
                            </TableCell>
                            <TableCell>{item?.referenceCode}</TableCell>
                            <TableCell>{item.referenceText}</TableCell>
                            <TableCell>
                              {item.isActive ? "Yes" : "No"}
                            </TableCell>

                            <TableCell align="right">
                              <Tooltip title="Edit">
                                <EditIcon
                                  color="success"
                                  sx={{ "&:hover": { cursor: "pointer" } }}
                                  onClick={() => {
                                    setUpdateId(item.referenceId);
                                    setGetDataFromID(item.referenceId);

                                    setOpenModel(true);
                                  }}
                                />
                              </Tooltip>
                              <Tooltip title="Delete">
                                <DeleteIcon
                                  color="error"
                                  sx={{ "&:hover": { cursor: "pointer" } }}
                                  onClick={() => {
                                    setDeleteID(item.referenceId);
                                    setGetDataFromID(item.referenceId);

                                    setOpenModel(true);

                                    //   handleOpenModel();
                                  }}
                                />
                              </Tooltip>
                              <Tooltip title="Enable/Disable">
                                {item.isActive ? (
                                  <ToggleOnIcon
                                    sx={{ "&:hover": { cursor: "pointer" } }}
                                    color="info"
                                    onClick={() => {
                                      settogglebutton(item.referenceId);

                                      setOpenModel(true);
                                    }}
                                  />
                                ) : (
                                  <ToggleOffIcon
                                    onClick={() => {
                                      settogglebutton(item.referenceId);

                                      setOpenModel(true);
                                    }}
                                  />
                                )}
                              </Tooltip>
                              {/* <Tooltip title="Enable/Disable">
                          <Switch  
                          fontSize="small"
                          color="info"
                          
                          sx={{ "&:hover": { cursor: "pointer" } ,marginBottom:"12px"}}
                          checked={item.isActive ? true : false}
                          name=""
                          onClick={()=>{
                            settogglebutton(item.referenceId)

                            setOpenModel(true);

                          }}
                          />

                          </Tooltip> */}
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    );
                  })}
                </TableBody>
                {invoiceLoader && (
                  <TableSkeleton noOfColumns={5} noOfLines={5} />
                )}
              </Table>
              {getdata?.length === 0 && !invoiceLoader ? <EmptyData /> : ""}
            </TableContainer>
          </CardBody>
        </Card>
        {openModel && (
          <SG_PM_TT_PTModel
            refKey={refKey}
            getdata={getdata}
            setOpenModel={setOpenModel}
            updateId={updateId}
            setUpdateId={setUpdateId}
            togglebutton={togglebutton}
            settogglebutton={settogglebutton}
            deleteId={deleteId}
            setDeleteID={setDeleteID}
            setSuccessMessage={setSuccessMessage}
            setErrorMessage={setErrorMessage}
            getdataFromID={getdataFromID}
            setGetDataFromID={setGetDataFromID}
            setGetData={setGetData}
          />
        )}
        {successMessage && (
          <CustomSnackbar
            open={successMessage !== ""}
            message={successMessage}
            handleClose={() => setSuccessMessage("")}
            variant="success"
          />
        )}
        {errorMessage && (
          <>
            {" "}
            <Grid container spacing={0}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />{" "}
              </Grid>
              <Grid item>
                <Typography className={classes.asterisk} ml={1}>
                  {" "}
                  {errorMessage}
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
      </div>
    </>
  );
};

export default SG_PM_TT_PTSetting;
